import styled, { css } from "styled-components";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";

export const Wrapper = styled.div<{ fullscreen?: boolean }>`
    position: relative;
    width: 100%;
    height: 100vh;
    max-height: 100vh;

    ${({ fullscreen }) =>
        !fullscreen &&
        css`
            height: 360px;
            @media ${getBreakpoint("up", "lg")} {
                height: 420px;
            }
            @media ${getBreakpoint("up", "lg")} {
                height: 680px;
            }
        `}
`;

export const CanvasWrapper = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: -17px;
    right: -17px;

    /* container size + sides jutting out + extra padding for scrollbar */
    @media screen and (min-width: ${1140 + 40 * 2 + 20}px) {
        left: -40px;
        right: -40px;
    }

    canvas {
        width: 100%;
        height: 100%;
        outline: none;
        cursor: move;
    }
`;
